import { classes } from 'html-classes';
import React from 'react';
import { useTranslation } from 'react-i18next';

import HeaderIconBanner from '~/components/HeaderIconBanner/HeaderIconBanner';

import styles from './BannersDropdown.module.scss';

const BannersDropdown = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const bannersRef = React.useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  React.useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (
        bannersRef.current &&
        !bannersRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const infoBanners = [
    {
      icon: 'certificate' as const,
      title: t('phrases:originatProduct'),
      subtitle: t('phrases:originalCertified'),
    },
    {
      icon: 'plane' as const,
      title: t('phrases:reliableDelivery'),
      subtitle: t('phrases:speedDelivery'),
    },
    {
      icon: 'sale' as const,
      title: t('phrases:goodPrice'),
      subtitle: t('phrases:discount'),
    },
  ];

  const statsBanners = [
    {
      icon: 'box-de' as const,
      title: t('translation:ordersV2'),
      subtitle: '152 К',
      variant: 'gray' as const,
    },
    {
      icon: 'chat-circle' as const,
      title: t('translation:reviewsV2'),
      subtitle: '60,6 К',
      variant: 'gray' as const,
    },
    {
      icon: 'star-badge' as const,
      title: t('phrases:averageProductRating'),
      subtitle: '5 из 5',
      variant: 'gray' as const,
    },
  ];

  return (
    <div className={styles.root} ref={bannersRef}>
      <HeaderIconBanner
        icon={'certificate'}
        title={t('phrases:originatProduct')}
        subtitle={t('phrases:moreDetail')}
        className={styles.trigger}
        endIcon="chevron"
        endIconClassName={classes([
          styles.triggerIcon,
          isOpen && styles.triggerIconOpen,
        ])}
        onClick={() => setIsOpen((prev) => !prev)}
        ariaExpanded={isOpen}
      />
      {isOpen && (
        <div className={styles.content}>
          <div className={styles.section}>
            {infoBanners.map((banner) => (
              <HeaderIconBanner
                key={`${banner.icon}-${banner.title}`}
                icon={banner.icon}
                title={banner.title}
                subtitle={banner.subtitle}
                className={styles.item}
              />
            ))}
          </div>
          <div className={styles.section}>
            <div className={styles.row}>
              {statsBanners.slice(0, 2).map((banner) => (
                <HeaderIconBanner
                  key={`${banner.title}-${banner.subtitle}`}
                  icon={banner.icon}
                  title={banner.title}
                  subtitle={banner.subtitle}
                  variant={banner.variant}
                  className={styles.item}
                />
              ))}
            </div>
            {statsBanners.slice(2).map((banner) => (
              <HeaderIconBanner
                key={`${banner.title}-${banner.subtitle}`}
                icon={banner.icon}
                title={banner.title}
                subtitle={banner.subtitle}
                variant={banner.variant}
                className={styles.item}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BannersDropdown;
